import { Pipe, PipeTransform } from '@angular/core';
import { formatCNPJ, formatCPF } from './../../utils/document';

@Pipe({
  name: 'cpfCnpj',
})
export class CpfCnpjPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    if (!value) return null;
    const document = value.replace(/[^0-9]/g, '');
    if (document.length <= 11) {
      return formatCPF(document);
    } else if (document.length === 14) {
      return formatCNPJ(document);
    }
    return value;
  }
}
